<template>
  <span
    :aria-label="label || $t.quantity"
    :class="brandClasses.container"
    data-test-id="vf-stepper"
    role="group"
  >
    <base-button
      :aria-disabled="disabled || model <= min"
      :aria-label="`${model - step <= min ? $t.remove : $t.decrease} ${label || $t.quantity}`"
      :class="[brandClasses.button, { [brandClasses.buttonDisabled!]: disabled || model <= min }]"
      data-test-id="vf-stepper-decrease-button"
      @click="handleClickDecrease"
    >
      <slot name="decrease-icon" :size="iconSize">
        <vf-icon name="minus" :size="iconSize" />
      </slot>
    </base-button>
    <span
      aria-atomic="true"
      aria-live="polite"
      :class="[brandClasses.display, { [brandClasses.displayDisabled!]: disabled }]"
    >
      {{ model }}
    </span>
    <base-button
      :aria-disabled="disabled || model >= max"
      :aria-label="`${$t.increase} ${label || $t.quantity}`"
      :class="[brandClasses.button, { [brandClasses.buttonDisabled!]: disabled || model >= max }]"
      data-test-id="vf-stepper-increase-button"
      @click="handleClickIncrease"
    >
      <vf-icon name="plus" :size="iconSize" />
    </base-button>
  </span>
</template>

<script lang="ts" setup>
const { min = 1, max = 100, step = 1, disabled } = defineProps<{
  /**
   * Minimum value inclusive
   */
  min?: number
  /**
   * Maximum value inclusive
   */
  max?: number
  /**
   * Step increase/decrease by pressing the buttons
   */
  step?: number
  /**
   * Defines disabled state
   */
  disabled?: boolean
  /**
   * Accessible label for stepper
   */
  label?: string
}>()

const model = defineModel<number>({ default: 1 })

const { brandClasses, iconSize } = useAppConfig().components.vf.stepper

const handleClickDecrease = () => {
  if (disabled || model.value <= min) return
  model.value -= step
}

const handleClickIncrease = () => {
  if (disabled || model.value >= max) return
  model.value += step
}
</script>
